// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__ocTI2","content":"RecentSearches_content__1IVIp"};